import { render, staticRenderFns } from "./fanx.vue?vue&type=template&id=418cd048&scoped=true&"
import script from "./fanx.vue?vue&type=script&lang=js&"
export * from "./fanx.vue?vue&type=script&lang=js&"
import style0 from "./fanx.vue?vue&type=style&index=0&id=418cd048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418cd048",
  null
  
)

export default component.exports